import {Table, Badge} from "antd";
import styled from "styled-components";

export const ResponsiveTableContainer = styled(Table)`
    width: 100%;

    .ant-table-content {
        overflow-x: auto;
    }

    .ant-table-tbody > tr > td[data-label*="Onayla"] .ant-row {
        justify-content: center;
        align-items: center;
    }

    @media screen and (max-width: 768px) {
        .ant-table {
            font-size: 13px;
        }

        .ant-table-thead > tr > th {
            display: none;
        }

        .ant-table-tbody > tr {
            display: block;
            margin-bottom: 16px;
            border: 1px solid #e8e8e8;
            border-radius: 8px;
            box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
            background: white;
            overflow: hidden;
        }

        .ant-table-tbody > tr > td {
            display: flex;
            flex-direction: column;
            padding: 12px 16px;
            border: none;
            border-bottom: 1px solid #f0f0f0;
            position: relative;
        }

        .ant-table-tbody > tr > td:last-child {
            border-bottom: none;
        }

        .ant-table-tbody > tr > td::before {
            content: attr(data-label) ": ";
            font-weight: 600;
            color: #333;
            font-size: 12px;
            margin-bottom: 8px;
        }

        .ant-table-tbody > tr > td:first-child {
            padding-top: 16px;
        }

        .ant-table-tbody > tr > td:last-child {
            padding-bottom: 16px;
        }

        .ant-table-tbody > tr > td .ant-row {
            width: 100%;
            flex-wrap: wrap;
        }

        .ant-table-tbody > tr > td .ant-tag {
            margin: 0;
        }

        .ant-table-tbody > tr > td .ant-btn {
            margin-top: 4px;
            margin-right: 4px;
        }

        .ant-table-tbody > tr > td[data-label*="Onayla"] {
            align-items: center;
        }

        .ant-table-tbody > tr > td[data-label*="Onayla"] .ant-row {
            justify-content: center;
            align-items: center;
            width: 100%;
        }

        .ant-table-tbody > tr > td[data-label*="Onayla"] .ant-btn {
            margin: 4px;
            min-width: 80px;
        }
    }
`;

export const HistoryButtonWrapper = styled.div`
    display: inline-flex;
    margin-left: 5px;
`;

export const HistoryRejectionBadge = styled(Badge)`
    .ant-badge-count {
        min-width: 14px;
        height: 14px;
        padding: 0 3px;
        font-size: 10px;
        line-height: 14px;
        box-shadow: 0 0 0 1px #fff;
    }

    @media screen and (max-width: 768px) {
        .ant-badge-count {
            min-width: 18px;
            height: 18px;
            padding: 0 4px;
            font-size: 11px;
            line-height: 18px;
        }
    }
`;
